;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/articles/:slug\",\"regex\":\"^/articles/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/categories/:slug\",\"regex\":\"^/categories/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/search\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.1";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env["NEXT_PUBLIC_SENTRY_DSN"],
  environment: process.env["NEXT_PUBLIC_APP_ENV"] ?? "development",
  sendDefaultPii: false,
  // ブラウザ拡張機能が注入したスクリプトのエラーはこちらのコードで直しようがないため除外する
  denyUrls: [
    /extensions\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-web-extension:\/\//i,
  ],
  ignoreErrors: ["Script error.", "top.GLOBALS", "ResizeObserver loop limit exceeded"],
  beforeSend(event, hint) {
    const error = hint.originalException;
    const status =
      error && typeof error === "object" && "status" in error ? error.status : undefined;
    // 5xx・ステータス不明なものは Sentry に送る。
    if (typeof status !== "number" || status >= 500) {
      return event;
    }
    return null;
  },
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
